const map = {
	"./dental/open-mouth.svg": 47690,
	"./eye/eye.svg": 3762,
	"./general/body-shape.svg": 62702,
	"./general/head-crosssection.svg": 55920,
	"./general/lungs.svg": 42329
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47125;